import { render } from "./ManageApiKeys.vue?vue&type=template&id=89a04886&scoped=true"
import script from "./ManageApiKeys.vue?vue&type=script&lang=js"
export * from "./ManageApiKeys.vue?vue&type=script&lang=js"

import "./ManageApiKeys.vue?vue&type=style&index=0&id=89a04886&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-89a04886"]])

export default __exports__